import { render, staticRenderFns } from "./LeadsNew.vue?vue&type=template&id=38e37b54&scoped=true"
import script from "./LeadsNew.vue?vue&type=script&lang=js"
export * from "./LeadsNew.vue?vue&type=script&lang=js"
import style0 from "./LeadsNew.vue?vue&type=style&index=0&id=38e37b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e37b54",
  null
  
)

export default component.exports